/* eslint-disable */
// Raw HTML for the Shift Farm visual mockups (rendered inside an iframe via srcDoc).
// The PNGs live in /app/frontend/public/farm-assets/ and are Nano-Banana generated.
const html = String.raw`<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>Shift Farm — Painted Mockups</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Fraunces:wght@600;800&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
<style>
  :root{
    --emerald:#059669; --slate-900:#0f172a; --slate-700:#334155;
    --slate-500:#64748b; --slate-200:#e2e8f0;
  }
  html,body{margin:0;padding:0;background:#f8fafc;color:var(--slate-900);font-family:'Inter',sans-serif;-webkit-font-smoothing:antialiased}
  .wrap{max-width:1180px;margin:0 auto;padding:48px 24px 96px}
  .kicker{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--emerald)}
  h1{font-family:'Fraunces',serif;font-weight:800;font-size:38px;line-height:1.1;letter-spacing:-.02em;margin:6px 0 6px}
  .lede{color:var(--slate-500);max-width:660px;line-height:1.55;margin-bottom:32px;font-size:15px}
  h2{font-family:'Fraunces',serif;font-weight:700;font-size:24px;letter-spacing:-.01em;margin:64px 0 8px}
  h2 .num{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:var(--emerald);color:#fff;font-family:'Inter';font-size:14px;font-weight:700;margin-right:10px;vertical-align:2px}
  .note{color:var(--slate-500);font-size:14px;margin-bottom:20px;max-width:720px;line-height:1.55}

  .card{background:#fff;border:1px solid var(--slate-200);border-radius:20px;padding:0;overflow:hidden;box-shadow:0 1px 2px rgba(15,23,42,.04),0 12px 30px -20px rgba(15,23,42,.15)}
  .card .hdr{padding:14px 20px;border-bottom:1px solid var(--slate-200);display:flex;align-items:center;justify-content:space-between;background:#fafbfc}
  .card .hdr .title{font-weight:600;font-size:14px;color:var(--slate-700);display:flex;gap:8px;align-items:center}
  .dot{width:9px;height:9px;border-radius:50%;background:#ff5f57;box-shadow:14px 0 0 #febc2e,28px 0 0 #28c840}
  .cta{padding:6px 12px;background:var(--emerald);color:#fff;border-radius:999px;font-size:12px;font-weight:600}

  /* --- login banner --- */
  .banner-frame{position:relative;height:320px;overflow:hidden;background:#0b1f2f}
  .banner-frame img{width:100%;height:100%;object-fit:cover;display:block}
  .banner-scene{width:100%;height:100%;transform-origin:52% 62%;animation:bannerZoom 1.8s cubic-bezier(.22,.9,.25,1) both}
  @keyframes bannerZoom{
    0%   { transform: scale(0.68) translateY(28px); filter: blur(1.5px) saturate(.7); opacity: 0 }
    60%  { transform: scale(1.02) translateY(0);    filter: blur(0) saturate(1);      opacity: 1 }
    100% { transform: scale(1)    translateY(0);    filter: blur(0) saturate(1);      opacity: 1 }
  }
  .banner-overlay{position:absolute;inset:auto 0 0 0;padding:20px 24px;display:flex;align-items:flex-end;justify-content:space-between;pointer-events:none;background:linear-gradient(transparent,rgba(0,0,0,.55))}
  .banner-title{color:#fff;text-shadow:0 2px 12px rgba(0,0,0,.6);font-family:'Fraunces',serif;font-weight:800;font-size:26px;letter-spacing:-.01em}
  .banner-sub{color:#f8fafc;text-shadow:0 1px 8px rgba(0,0,0,.6);font-size:13px;font-weight:500;margin-top:2px}
  .badge-pill{display:inline-flex;gap:6px;align-items:center;background:rgba(255,255,255,.94);border-radius:999px;padding:8px 14px;font-size:12px;font-weight:700;color:#0f5f2e;box-shadow:0 6px 22px rgba(0,0,0,.25)}
  .sparkle{position:absolute;width:16px;height:16px;background:radial-gradient(circle,#fde68a 0%,rgba(253,230,138,0) 65%);animation:sparkleRise 2.4s ease-out infinite;pointer-events:none}
  .sparkle.s1{left:48%;bottom:40%;animation-delay:.3s}
  .sparkle.s2{left:56%;bottom:35%;animation-delay:.9s}
  .sparkle.s3{left:42%;bottom:52%;animation-delay:1.5s}
  @keyframes sparkleRise{
    0%{transform:translateY(20px) scale(.5);opacity:0}
    30%{opacity:1}
    100%{transform:translateY(-40px) scale(1.2);opacity:0}
  }
  .legend{display:flex;gap:10px;flex-wrap:wrap;margin-top:20px}
  .legend .pill{background:#fff;border:1px solid var(--slate-200);border-radius:999px;padding:6px 12px;font-size:12px;color:var(--slate-700)}

  /* --- level growth grid --- */
  .grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
  @media (max-width:900px){ .grid{grid-template-columns:repeat(2,1fr)} }
  @media (max-width:560px){ .grid{grid-template-columns:1fr} }
  .lvl{background:#fff;border:1px solid var(--slate-200);border-radius:18px;overflow:hidden;transition:transform .25s ease,box-shadow .25s ease}
  .lvl:hover{transform:translateY(-6px);box-shadow:0 24px 45px -22px rgba(15,23,42,.35)}
  .lvl .art{aspect-ratio:5/4;background:#0b1f2f;position:relative;overflow:hidden}
  .lvl .art img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s ease}
  .lvl:hover .art img{transform:scale(1.05)}
  .lvl .meta{padding:14px 16px}
  .lvl .row1{display:flex;align-items:center;justify-content:space-between;gap:6px}
  .lvl .tier{font-family:'Fraunces',serif;font-weight:700;font-size:16px}
  .lvl .lvlchip{font-size:10px;letter-spacing:.08em;text-transform:uppercase;font-weight:800;padding:3px 8px;border-radius:999px;background:var(--slate-200);color:var(--slate-700)}
  .lvl .lvlchip.l1{background:#ecfccb;color:#3f6212}
  .lvl .lvlchip.l2{background:#d1fae5;color:#065f46}
  .lvl .lvlchip.l3{background:#dbeafe;color:#1e40af}
  .lvl .lvlchip.l4{background:#fef3c7;color:#92400e}
  .lvl .lvlchip.l5{background:#fed7aa;color:#9a3412}
  .lvl .lvlchip.l6{background:#fae8ff;color:#86198f}
  .lvl .xp{color:var(--slate-500);font-size:12px;margin-top:4px}
  .lvl .desc{color:var(--slate-700);font-size:13px;line-height:1.5;margin-top:8px}
  .lvl.legendary{position:relative}
  .lvl.legendary::after{content:"";position:absolute;inset:0;border-radius:18px;pointer-events:none;box-shadow:inset 0 0 0 2px #fbbf24,0 0 30px -6px #fbbf24}

  /* --- placement card --- */
  .place{display:grid;grid-template-columns:1.05fr .95fr;gap:24px;align-items:center;background:#fff;border:1px solid var(--slate-200);border-radius:20px;padding:24px;margin-top:16px}
  @media (max-width:820px){ .place{grid-template-columns:1fr} }
  .place ul{margin:8px 0 0;padding-left:18px;color:var(--slate-700);font-size:14px;line-height:1.65}
  .place h3{font-family:'Fraunces',serif;font-weight:700;font-size:20px;margin:0}
  .miniapp{background:#0f172a;border-radius:16px;padding:14px;color:#e2e8f0;font-size:12px;min-height:280px;position:relative;overflow:hidden}
  .miniapp .topbar{display:flex;align-items:center;justify-content:space-between;padding-bottom:10px;border-bottom:1px solid #1f2a44;margin-bottom:10px}
  .miniapp .brand{font-family:'Fraunces',serif;font-weight:800;color:#fff}
  .miniapp .stat{display:inline-flex;align-items:center;gap:6px;background:#1e293b;padding:4px 10px;border-radius:999px;font-weight:600;color:#fde68a}
  .miniapp .heroart{position:relative;height:150px;border-radius:12px;overflow:hidden}
  .miniapp .heroart img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
  .miniapp .barfill{margin-top:10px;height:6px;background:#1e293b;border-radius:999px;overflow:hidden}
  .miniapp .barfill span{display:block;height:100%;width:64%;background:linear-gradient(90deg,#10b981,#f59e0b)}
  .miniapp .foot{margin-top:10px;font-size:11px;color:#94a3b8;display:flex;justify-content:space-between}

  .disclaimer{margin-top:32px;padding:14px 16px;background:#fef9c3;border:1px solid #fde68a;border-radius:12px;color:#713f12;font-size:13px;line-height:1.55}
  .toolbar{position:sticky;top:0;background:rgba(248,250,252,.92);backdrop-filter:blur(10px);z-index:10;display:flex;justify-content:space-between;align-items:center;padding:12px 24px;border-bottom:1px solid var(--slate-200)}
  .toolbar a{color:var(--slate-500);font-size:13px;text-decoration:none}
  .toolbar button{background:var(--emerald);color:#fff;border:0;padding:8px 14px;border-radius:999px;font-weight:600;cursor:pointer;font-size:13px}
</style>
</head>
<body>
<div class="toolbar">
  <a href="/" target="_top">← Back to app</a>
  <button onclick="replay()">↺ Replay login animation</button>
</div>
<div class="wrap">

  <div class="kicker">Shift Farm · Painted mockups</div>
  <h1>Painted farm mockups (Nano Banana generated).</h1>
  <p class="lede">Real illustrations this time — Hay Day / Stardew inspired. Nothing wired into the real Shift Farm yet. Look through them, pick a direction, and I'll build it in.</p>

  <h2><span class="num">1</span>Login banner — the farm greets you</h2>
  <p class="note">On landing on Shift Farm, the painted farmstead zooms in from ~0.7× over 1.8s. Once settled it becomes the header of the tab. Hit ↺ Replay up top to see the zoom again.</p>

  <div class="card">
    <div class="hdr">
      <div class="title"><span class="dot"></span> app.shiftfarm — welcome screen</div>
      <div class="cta">Level 3 · Farmhand</div>
    </div>
    <div class="banner-frame">
      <div class="banner-scene" id="bannerScene">
        <img src="/farm-assets/banner_login.png" alt="Farm banner"/>
      </div>
      <div class="sparkle s1"></div>
      <div class="sparkle s2"></div>
      <div class="sparkle s3"></div>
      <div class="banner-overlay">
        <div>
          <div class="banner-title">Welcome back, Liam.</div>
          <div class="banner-sub">Your farm missed you · +8 coins claimed while you were gone</div>
        </div>
        <div class="badge-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 L14 8 L20 8 L15 12 L17 18 L12 14 L7 18 L9 12 L4 8 L10 8 Z"/></svg>
          Level 3 · 340 XP
        </div>
      </div>
    </div>
  </div>

  <div class="legend">
    <span class="pill">⏱ ~1.8s zoom-in</span>
    <span class="pill">🌾 Once per session · collapses after</span>
    <span class="pill">✨ Idle sparkles above the barn</span>
    <span class="pill">♿ Respects prefers-reduced-motion</span>
  </div>

  <h2><span class="num">2</span>Level growth — the farm literally grows</h2>
  <p class="note">A big illustration at the top of Shift Farm that swaps as the player ranks up. Every tier gets a new painted scene — very obvious progression, hover to see it breathe.</p>

  <div class="grid">
    <div class="lvl">
      <div class="art"><img src="/farm-assets/level1_sprout.png" alt="Sprout"/></div>
      <div class="meta">
        <div class="row1"><div class="tier">Sprout</div><div class="lvlchip l1">L1</div></div>
        <div class="xp">0 – 99 XP</div>
        <div class="desc">Just a seedling in the dirt. Plant your first open shift to grow.</div>
      </div>
    </div>
    <div class="lvl">
      <div class="art"><img src="/farm-assets/level2_sapling.png" alt="Sapling"/></div>
      <div class="meta">
        <div class="row1"><div class="tier">Sapling</div><div class="lvlchip l2">L2</div></div>
        <div class="xp">100 – 299 XP</div>
        <div class="desc">A young sapling and the first fence. The farm has bones.</div>
      </div>
    </div>
    <div class="lvl">
      <div class="art"><img src="/farm-assets/level3_farmhand.png" alt="Farmhand"/></div>
      <div class="meta">
        <div class="row1"><div class="tier">Farmhand</div><div class="lvlchip l3">L3</div></div>
        <div class="xp">300 – 699 XP</div>
        <div class="desc">Little red shed and your first chicken clucking around.</div>
      </div>
    </div>
    <div class="lvl">
      <div class="art"><img src="/farm-assets/level4_farmer.png" alt="Farmer"/></div>
      <div class="meta">
        <div class="row1"><div class="tier">Farmer</div><div class="lvlchip l4">L4</div></div>
        <div class="xp">700 – 1499 XP</div>
        <div class="desc">Full barn, cow, scarecrow and a small vegetable patch.</div>
      </div>
    </div>
    <div class="lvl">
      <div class="art"><img src="/farm-assets/level5_harvest_master.png" alt="Harvest Master"/></div>
      <div class="meta">
        <div class="row1"><div class="tier">Harvest Master</div><div class="lvlchip l5">L5</div></div>
        <div class="xp">1500 – 2999 XP</div>
        <div class="desc">Silo, wheat fields, sheep, windmill — a thriving homestead.</div>
      </div>
    </div>
    <div class="lvl legendary">
      <div class="art"><img src="/farm-assets/level6_legendary.png" alt="Legendary"/></div>
      <div class="meta">
        <div class="row1"><div class="tier">Legendary Farmer</div><div class="lvlchip l6">L6</div></div>
        <div class="xp">3000+ XP</div>
        <div class="desc">Crown, rainbow, tractor and the full menagerie. Bragging rights.</div>
      </div>
    </div>
  </div>

  <h2><span class="num">3</span>Where it lives in the app</h2>
  <p class="note">A single "Your farm" card at the top of the Shift Farm tab (above the seed board). The illustration changes automatically as the player levels up.</p>
  <div class="place">
    <div class="miniapp">
      <div class="topbar">
        <div class="brand">Shift Farm</div>
        <div class="stat">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#fde68a"><circle cx="12" cy="12" r="10"/></svg>
          428 coins
        </div>
      </div>
      <div class="heroart">
        <img src="/farm-assets/level3_farmhand.png" alt="Your farm"/>
      </div>
      <div style="margin-top:12px;font-weight:600;color:#fff">Level 3 · Farmhand</div>
      <div class="barfill"><span></span></div>
      <div class="foot"><span>340 / 700 XP</span><span>360 XP to Level 4</span></div>
    </div>
    <div>
      <h3>Your farm — one card, big payoff</h3>
      <ul>
        <li>Sits above the Seeds / Trades / Store tabs — first thing you see.</li>
        <li>Illustration changes automatically at each level threshold.</li>
        <li>Progress bar underneath shows XP to the next tier.</li>
        <li>Legendary tier gets a subtle golden glow ring around the card.</li>
        <li>Tapping the card can open a bigger "farm story" view later.</li>
      </ul>
    </div>
  </div>

  <div class="disclaimer">
    <strong>Nothing here is wired into the app yet.</strong> This is a preview only. Say the word and I'll wire the login banner + growing farm card into the real Shift Farm tab.
  </div>
</div>
<script>
  function replay(){
    const s = document.getElementById('bannerScene');
    s.style.animation = 'none';
    void s.offsetWidth;
    s.style.animation = '';
  }
</script>
</body>
</html>`;
export default html;
